/**
 * Opens the CAE Help portal in a new browser tab.
 * Used across the application for help/support links.
 *
 * The parameter is typed as `boolean | object` so the function can be passed
 * directly as a DOM event handler (e.g. `onClick={navigateToHelp}`). In that
 * case a MouseEvent is received; the `=== true` guard ensures only an explicit
 * `true` selects the public URL — all other values (including events) fall
 * back to the private URL.
 */
export function navigateToHelp(usePublicLink: boolean | object = false): void {
  const helpUrl =
    usePublicLink === true
      ? import.meta.env.VITE_HELP_HOME_PUBLIC_URL
      : import.meta.env.VITE_HELP_HOME_URL;
  window.open(helpUrl, '_blank', 'noopener,noreferrer');
}
